import * as React from 'react';
export const IcFlower = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 15a7.55 7.55 0 00-5 1.81v-2a2.87 2.87 0 01-2 0v2A7.55 7.55 0 006 15a1 1 0 00-1 1c0 3.31 3.14 6 7 6s7-2.69 7-6a1 1 0 00-1-1zM6.8 11a2 2 0 002.74.73l.46-.27V12a2 2 0 004 0v-.54l.46.27A2.001 2.001 0 0017.2 11a1.999 1.999 0 00-.74-2.73L16 8l.46-.27a2 2 0 10-2-3.46l-.46.27V4a2 2 0 10-4 0v.54l-.46-.27a2 2 0 10-2 3.46L8 8l-.46.27A2 2 0 006.8 11zM12 6.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z'
      fill='currentColor'
    />
  </svg>
);
